// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"93938510","administration":"9a637032"}[chunkId] + ".chunk.js";
};